<template lang="pug">
  span(
    v-if="!onlyText"
    class="document-status"
    :class="`document-status--${value}`"
  )
    span(
      class="document-status__dot mr-2"
      :class="`document-status__dot--${value}`"
    )
    span {{ statusText }}
  span(
    v-else
    class="no-bg"
    :class="`document-status--${value}`"
  ) {{ statusText }}
</template>

<script>
import { DOCUMENT_STATUSES_SELECT } from '~/modules/documents/constants/documents'

export default {
  name: 'EDocumentsStatus',
  props: {
    value: {
      type: String,
      default: ''
    },
    onlyText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    statusText() {
      const status = DOCUMENT_STATUSES_SELECT.find(item => item.value === this.value)
      return status ? status.text : '-'
    }
  }
}
</script>

<style lang="scss">
.document-status {
  display: inline-block;
  border-radius: 20px;
  padding: 6px 12px;

  &--new {
    background: rgba(0, 0, 0, 0.08);
    color: #000;
  }

  &--signed {
    background: rgba(33, 150, 83, 0.08);
    color: #219653;
  }

  &--approved {
    background: rgba(33, 150, 83, 0.08);
    color: #219653;
  }

  &--rejected {
    background: rgba(255, 23, 68, 0.08);
    color: $danger;
  }

  &--cancelled {
    background: rgba(255, 23, 68, 0.08);
    color: $danger;
  }

  &--sent_for_sign {
    color: #2f80ed;
    background: rgba(47, 128, 237, 0.08);
  }

  &--sent_for_approve {
    color: #04aed4;
    background: rgba(4, 174, 212, 0.08);
  }

  &--waiting_for_your_sign {
    color: #ffaa01;
    background: rgba(255, 170, 1, 0.08);
  }

  &--waiting_for_contractor_sign {
    color: #ffaa01;
    background: rgba(255, 170, 1, 0.08);
  }

  &--waiting_for_approve {
    color: #f2994a;
    background: rgba(242, 153, 74, 0.08);
  }

  &--viewed {
    color: #04aed4;
    background: rgba(4, 174, 212, 0.08);
  }

  &--waiting_for_view {
    background: rgba(143, 37, 125, 0.08);
    color: $primary;
  }

  &--filled {
    background: rgba(55, 223, 28, 0.08);
    color: #37df1c;
  }

  &--waiting_for_fill {
    background: rgba(212, 223, 25, 0.08);
    color: #d4df19;
  }

  &--sent_for_fill {
    background: rgba(66, 139, 223, 0.08);
    color: #428bdf;
  }
}
.document-status__dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 100%;

  &--new {
    background: #000;
  }

  &--signed {
    background: #219653;
  }

  &--approved {
    background: #219653;
  }

  &--rejected {
    background: #ff1744;
  }

  &--cancelled {
    background: #ff1744;
  }

  &--sent_for_sign {
    background: #2f80ed;
  }

  &--sent_for_approve {
    background: #04aed4;
  }

  &--waiting_for_your_sign {
    background: #ffaa01;
  }

  &--waiting_for_contractor_sign {
    background: #ffaa01;
  }

  &--waiting_for_approve {
    background: #f2994a;
  }

  &--viewed {
    background: #04aed4;
  }

  &--waiting_for_view {
    background: $primary;
  }

  &--filled {
    background: #37df1c;
  }

  &--waiting_for_fill {
    background: #d4df19;
  }

  &--sent_for_fill {
    background: #428bdf;
  }
}
.no-bg {
  background: none !important;
}
</style>
